export const paths = {
  root: '/',
  login: '/login',
  register: '/register',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  twoFactorChallenge: '/two-factor-challenge',
  emailVerified: '/email-verified',
  verifyEmailNotice: '/verify-email',
  dashboard: '/dashboard',
  settings: '/settings',
  workspaces: '/workspaces',
  newWorkspace: '/workspaces/new',
  workbenchPattern: '/workspaces/:workspaceId',
  workbench: (id: string) => `/workspaces/${id}`,
  workspaceSettingsPattern: '/workspaces/:workspaceId/settings',
  workspaceSettings: (id: string) => `/workspaces/${id}/settings`,
  acceptInvitationPattern: '/invitations/:token',
  invitation: (token: string) => `/invitations/${token}`,
} as const;
